import React, { Component } from 'react'

import { FillerInlineDiv } from '../StyledComponents/Fillers'
import { SettingsInputTime, SettingsTitle, SettingsRow } from '../StyledComponents/Settings'

class SettingsRowTime extends Component {
    constructor(props) {
        super(props)

        this.onValueChange = this.onValueChange.bind(this)
    }

    onValueChange(e) {
        this.props.handleChange(e.target.value)
    }

    render() {
        const { title, currentValue } = this.props

        return (
            <SettingsRow>
                <SettingsTitle className="align-top col-6">{title}</SettingsTitle>
                <FillerInlineDiv className="col-6 text-right">
                    <SettingsInputTime value={currentValue || ''} onChange={this.onValueChange} type="time" />
                </FillerInlineDiv>
            </SettingsRow>
        )
    }
}

SettingsRowTime.defaultProps = {
    title: '',
    currentValue: '',
}

export default SettingsRowTime



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowTime.js